import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CompaniesSection from './components/CompaniesSection';
import PartnersSection from './components/PartnersSection';
import ServicesSection from './components/ServicesSection';
import DifferentialsSection from './components/DifferentialsSection';
import CTASection from './components/CTASection';

const Home = () => {
  return (
    <div className="min-h-screen bg-light">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CompaniesSection />
        <PartnersSection />
        <ServicesSection />
        <DifferentialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
